import {Component} from '@angular/core';
import { DbService } from '../_services/db.service';
import {ProjekteComponent} from './projekte.component';
import {Router} from '@angular/router';
import {AuthenticationService} from '../_services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'projekte-app-mobile',
  templateUrl: './projekte.component.mobile.html',
  styleUrls: ['../home/home.component.css']})

export class ProjekteMobileComponent extends ProjekteComponent{

  constructor(
    router: Router,
    service: DbService,
    authenticationService: AuthenticationService) {
    super(router, service, authenticationService);
  }

}
